import { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigationType } from 'react-router-dom';
import { SiteShell } from './components/SiteShell';
import { GamePage } from './pages/GamePage';
import { Home } from './pages/Home';
import { NotFound } from './pages/NotFound';
import { PrivacyPage } from './pages/legal/PrivacyPage';
import { TermsPage } from './pages/legal/TermsPage';
import { ParentsPage } from './pages/ParentsPage';
import { AboutPage } from './pages/AboutPage';
import { ArticlePage, GuidesPage } from './pages/GuidesPage';
import { UpdatesPage } from './pages/UpdatesPage';
import { trackPage } from './lib/analytics';

export function App() {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  useEffect(() => trackPage(pathname), [pathname]);
  // A newly opened page starts at the top (the Play button), not wherever the last page was scrolled.
  // Back and Forward (POP) keep the browser's own scroll restore.
  useEffect(() => {
    if (navType !== 'POP') window.scrollTo(0, 0);
  }, [pathname, navType]);
  return (
    <SiteShell>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/games/:slug" element={<Home />} />
        <Route path="/play/:id" element={<GamePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/parents" element={<ParentsPage />} />
        <Route path="/guides" element={<GuidesPage />} />
        <Route path="/guides/:slug" element={<ArticlePage />} />
        <Route path="/updates" element={<UpdatesPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </SiteShell>
  );
}
